import axiosInstance from "../Interceptor"

export const getCustomerOrderApi = (payload) => {
 
	return axiosInstance
		.get(`orders/api/v1/orders/${payload}/`)
		.then((response) => {
			return response
			
		})
		.catch((error) => {
			return error
		})
}